import { Component, h } from 'preact';
import { TcrLogin } from './login';
import { I } from 'intl';

class TcrLoginForm extends Component
{
    constructor(props)
    {
        super(props);

        I.Logout = { de: 'Abmelden', en: 'Log out' };
        I.Email = { de: 'E-Mail', en: 'Email' };
        I.Next = { de: 'Weiter', en: 'Next' };
        I.UserAlreadyExistsTitle = { de: 'Benutzer existiert bereits', en: 'User already exists' };
        I.UserAlreadyExistsText = { de: 'Für diese E-Mail Adresse gibt es bereits einen Account. Melden Sie sich jetzt mit Ihren Zugangsdaten an.', en: 'There is already an account for this Email address. Please log in with your credentials.' };
        I.LoginFailedTitle = { de: 'Fehler bei der Anmeldung', en: 'Login failed' };
        I.LoginFailedText = { de: 'Bitte überprüfen sie ihre Zugangsdaten.', en: 'Please check your credentials.' };
        I.NoConnectionTitle = { de: 'Keine Verbindung', en: 'Login failed' };
        I.NoConnectionText = { de: 'Bitte überprüfen Sie ihre Internetverbindung.', en: 'Please check your internet connection.' };

        I.Welcome = { de: 'Willkommen', en: 'Welcome' };
        I.InvalidEmail = { de: 'Ungültige E-Mail Adresse', en: 'Invalid email address' };
        I.PleaseEnterACorrentEmailAddress = { de: 'Bitte geben sie ihre E-Mail Adresse ein.', en: 'Please enter a valid email address' };
        I.PleaseEnterYourEmail = { de: 'Bitte geben sie ihre E-Mail Adresse ein um loszulegen.', en: 'Please enter your Email address to get started.' };
        I.UserNotInvited = { de: 'E-Mail Adresse unbekannt.', en: 'Email address unknown.' };
        I.UserNotInvitedText = { de: 'Für die eingegebene E-Mail Adresse liegen aktuell keine Daten vor. Wenden Sie sich an unseren Support falls Sie glauben dass hier ein Fehler vorliegt.', en: 'We could not find any information about the entered Email address. Please contact our support if you think this is an error.' };
        I.IfYouHaveTroubleContactOwner = { de: 'Zu der eingegebenen E-Mail Adresse konnten keine Informationen gefunden werden.', en: 'We could not find any information about the entered Email address.' };

        I.setLanguages(['en', 'de']);

        this.state = this.updateProps(props, {});

        const urlParams = new URLSearchParams(window.location.search);
        this.state.exit = decodeURI(urlParams.get('exit') || '');
        this.state.pwa = decodeURI(urlParams.get('pwa') || '') == 'true';

        let mail = decodeURIComponent((window.location.hash || '').replace('#/', ''));
        if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(mail))
        {
            window.history.replaceState({}, '', '#/');
            this.state.email = mail;
            console.log('email is set');
        }
    }

    componentWillReceiveProps(props)
    {
        this.setState(oldstate => {
            return this.updateProps(props, oldstate);
        });
    }

    updateProps(props, oldState)
    {
        return {
            mode: 'login',
            view: 'email',
            extras: [],
            email: oldState.email || '',
            title: (props.config ? props.config.title : '') || I.Welcome,
            infotext: (props.config ? props.config.infotext : '') || I.PleaseEnterYourEmail,
            not_invited_text: (props.config ? props.config.not_invited_text : '') || 'Für die Registrierung benötigen Sie eine Einladung von ihrer Organisation. Bitte sprechen Sie den Verantwortilchen an.',
            signup_title: (props.config ? props.config.signup_title : '') || 'Neu hier?',
            signup_infotext: (props.config ? props.config.signup_infotext : '') || 'Sie können sich jetzt direkt kostenlos registrieren.',
            signup_agb: props.config?.signup_agb,
            otp_login_title: (props.config ? props.config.otp_login_title : '') || 'Anmelden mit Sicherheitscode',
            otp_login_infotext: (props.config ? props.config.otp_login_infotext : '') || 'Sie können sich ganz bequem mit einem Sicherheitscode authentifizieren. Klicken Sie auf "Code anfordern", und wir senden Ihnen einen Code an die angegebene E-Mail Adresse.',
            name_title: (props.config ? props.config.name_title : '') || 'Wie heißen sie?',
            name_infotext: (props.config ? props.config.name_infotext : '') || 'Bitte geben sie hier ihren Namen ein. Ihr Name ist für alle Mitglieder ihrer Organisation sichtbar.',
            otp_title: (props.config ? props.config.otp_title : '') || 'Sicherheitscode',
            otp_infotext: (props.config ? props.config.otp_infotext : '') || 'Wir haben ihnen einen Bestätigungscode per E-Mail an \'%EMAIL%\'  gesendet. Bitte geben sie diesen Code hier ein.',
            login_title: (props.config ? props.config.login_title : '') || 'Anmeldung',
            login_infotext: (props.config ? props.config.login_infotext : '') || 'Melden sie sich mit ihrem Passwort an.',
            reset_password_title: (props.config ? props.config.reset_password_title : '') || 'Neues Passwort festlegen',
            reset_password_infotext: (props.config ? props.config.reset_password_infotext : '') || 'Bitte denken sie sich ein neues Passwort aus, mit dem sie sich zukünftig bei Smart Organizer anmelden.',
            new_password_title: (props.config ? props.config.new_password_title : '') || 'Passwort festlegen',
            new_password_infotext: (props.config ? props.config.new_password_infotext : '') || 'Bitte denken sie sich ein Passwort aus, mit dem sie sich zukünftig bei Smart Organizer anmelden.',
            reset_title: (props.config ? props.config.reset_title : '') || 'Passwort vergessen? Kein Problem!',
            reset_infotext: (props.config ? props.config.reset_infotext : '') || 'Sie können hier direkt ein neues Passwort festlegen.'
        };
    }

    componentDidMount()
    {
        //if (this.state.email) this.login();
    }

    login(param)
    {
        if (!this.validateEmail() && (this.state.view == 'email' || this.state.view == 'password'))
        {
            return this.showError('invalid_email');
        }
        else if (!this.state.password && this.state.view == 'password')
        {
            return this.showError('invalid_password');
        }
        else if (this.state.view == 'otp' && !this.validateOTP())
        {
            return this.showError('invalid_otp');
        }
        let pw = this.state.view == 'email' ? '' : this.state.password;
        let otp = (param == 'request_otp') ? 'request_otp' : this.state.otp;
        TcrLogin.login(this.state.email, pw, otp, (result, raw) =>
        {
            if (result == 'ok')
            {
                location.reload(); 
            }
            else if (result == 'otp_required')
            {
                this.setState({
                    view: 'otp',
                    otp: ''
                });
            }
            else if (result == 'password_required')
            {
                this.setState({
                    view: 'password',
                    otp: ''
                });
            }
            else if (result == 'can_register')
            {
                this.setState({
                    view: 'email',
                    mode: 'signup',
                    password: '',
                    password2: '',
                    otp: ''
                });
            }
            else if (result == 'can_otp_login')
            {
                this.setState({
                    view: 'email',
                    mode: 'otp_login',
                    extras: [raw.offer_registration === true ? 'offer_registration' : ''].filter(Boolean),
                    password: '',
                    password2: '',
                    otp: ''
                });
            }
            else if (result == 'server_selection')
            {
                this.setState({
                    view: 'server_selection',
                    server_selection: raw.server_selection
                });
            }
            else
            {
                this.showError(result);
            }
        });
    }

    login_otp()
    {
        if (!this.validateEmail() && (this.state.view == 'email' || this.state.view == 'otp'))
        {
            return this.showError('invalid_email');
        }
        else if (this.state.view == 'otp' && !this.validateOTP())
        {
            return this.showError('invalid_otp');
        }
        TcrLogin.login(this.state.email, '', this.state.otp, (result, raw) =>
        {
            if (result == 'ok')
            {
                location.reload(); 
            }
            else if (result == 'otp_required')
            {
                this.setState({
                    view: 'otp',
                    otp: ''
                });
            }
            else
            {
                this.showError(result);
            }
        });
    }

    reset()
    {
        if (this.state.view == 'email' && !this.validateEmail())
        {
            return this.showError('invalid_email');
        }
        else if (this.state.view == 'otp' && !this.validateOTP())
        {
            return this.showError('invalid_otp');
        }
        else if (this.state.view == 'new_password' && !this.validatePassword())
        {
            return this.showError('invalid_password');
        }
        TcrLogin.reset(this.state.email, this.state.otp, this.state.password, (result) =>
        {
            if (result == 'ok')
            {
                this.showError('password_set', () => {
                    this.cancel();
                });
            }
            else if (result == 'otp_required')
            {
                this.setState({
                    view: 'otp',
                    otp: ''
                });
            }
            else if (result == 'password_required')
            {
                this.setState({
                    view: 'new_password',
                    password: '',
                    password2: ''
                });
            }
            else
            {
                this.showError(result);
            }
        });
    }

    signup()
    {
        if (this.state.view == 'email' && !this.validateEmail())
        {
            return this.showError('invalid_email');
        }
        else if (this.state.view == 'otp' && !this.validateOTP())
        {
            return this.showError('invalid_otp');
        }
        else if (this.state.view == 'new_password' && !this.validatePassword())
        {
            return this.showError('invalid_password');
        }
        else if (this.state.view == 'user' && !this.validateUser())
        {
            return this.showError('invalid_username');
        }
        else if (this.state.view == 'email' && this.state.signup_agb && !this.state.agb_accepted)
        {
            return this.showError('agb_not_accepted');
        }
        TcrLogin.signup(this.state.email, this.state.otp, this.state.password, this.state.name, (result) => 
        {
            if (result == 'ok')
            {
                this.showError('account_created', () => {
                    this.cancel();
                });
            }
            else if (result == 'otp_required')
            {
                this.setState({
                    mode: 'signup',
                    view: 'otp',
                    otp: ''
                });
            }
            else if (result == 'password_required')
            {
                this.setState({
                    view: 'new_password',
                    password: '',
                    password2: ''
                });
            }
            else if (result == 'name_required')
            {
                this.setState({
                    view: 'name',
                    name: ''
                });
            }
            else
            {
                this.showError(result);
            }
        });
    }
    

    showLostPassword()
    {
        this.setState({
            mode: 'reset',
            view: 'email',
            password: ''
        });
    }

    validateEmail()
    {
        if (
            !this.state.email ||
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(this.state.email)
        ) {
            return false;
        }
        return true;
    }

    validateOTP()
    {
        if (
            !this.state.otp ||
            !/[0-9]{6}/.test(this.state.otp)
        ) {
            return false;
        }
        return true;
    }

    validateUser()
    {
        if (
            !this.state.name
        ) {
            return false;
        }
        else
        {
            return true;
        }
    }

    validatePassword()
    {
        if (
            !this.state.password ||
            this.state.password != this.state.password2 ||
            !/.{10,}/.test(this.state.password) ||
            !/[a-z]/.test(this.state.password) ||
            !/[A-Z]/.test(this.state.password) ||
            !/[0-9]/.test(this.state.password) ||
            !/[^a-zA-Z0-9]/.test(this.state.password)
        ) {
            return false;
        }
        else
        {
            return true;
        }
    }

    showError(code, next)
    {
        let messages = {
            'user_already_exists': {
                type: 'success',
                title: I.UserAlreadyExistsTitle,
                text: I.UserAlreadyExistsText
            },
            'not_invited': {
                type: 'error',
                title: I.UserNotInvited,
                text: I.UserNotInvitedText
            },
            'invalid_email': {
                type: 'error',
                title: I.InvalidEmail,
                text: I.PleaseEnterACorrentEmailAddress,
            },
            'invalid_credentials': {
                type: 'error',
                title: I.LoginFailedTitle,
                text: I.LoginFailedText,
            },
            'no_connection': {
                type: 'error',
                title: I.NoConnectionTitle,
                text: I.NoConnectionText,
            },
            'login_failed': {
                type: 'error',
                title: I.LoginFailedTitle,
                text: I.LoginFailedText,
            },
            'invalid_otp': {
                type: 'error',
                title: 'Ungültiger Code',
                text: 'Bitte geben sie den 6-stelligen Sicherheitscode genauso ein, wie er in der E-Mail steht.',
            },
            'invalid_username': {
                type: 'error',
                title: 'Ungültiger Name',
                text: 'Bitte geben Sie Ihren Namen an, damit Kollegen wissen wer Sie sind.',
            },
            'invalid_password': {
                type: 'error',
                title: 'Ungültiges Passwort',
                text: 'Achten Sie auf die Mindestanforderungen und geben Sie zweimal das gleiche Passwort ein.',
            },
            'password_set': {
                type: 'success',
                title: 'Passwort geändert',
                text: 'Sie können sich nun mit Ihrem neuen Passwort anmelden.'
            },
            'account_created': {
                type: 'success',
                title: 'Erfolgreich',
                text: 'Ihr Account wurde erfolgreich angelegt. Sie können sich nun mit Ihrem Kennwort anmelden.'
            },
            'ip_locked_out': {
                type: 'error',
                title: 'Zugang gesperrt',
                text: 'Aus Sicherheitsgründen haben wir Ihren Zugang verübergehend gesperrt. Bitte versuchen Sie es in 20 Minuten erneut.'
            },
            'agb_not_accepted': {
                type: 'error',
                title: 'AGB oder Datenschutz nicht akzeptiert',
                text: 'Bitte akzeptieren Sie die Allgemeinen Geschäftsbedingungen und die Datenschutzerklärung um fortzufahren.'
            }
        }
        let message = messages[code] || {
            type: 'error',
            title: 'Fehler',
            text: code
        };
        if (typeof this.props.onError === 'function')
        {
            this.props.onError({
                title: message.title,
                text: message.text
            }).then(r =>
            {
                if (typeof next == 'function') next(r);
            });
        }
    }

    onKeyDown(e)
    {
        if (e.keyCode == 13)
        {
            if (this.state.mode == 'login')
            {
                this.login();
            }
        }
    }

    cancel()
    {
        if (this.state.mode == 'reset')
        {
            this.setState({
                view: 'password',
                mode: 'login',
                password: '',
                password2: '',
                otp: '',
                name: ''
            });
        }
        else
        {
            this.setState({
                view: 'email',
                mode: 'login',
                password: '',
                password2: '',
                otp: '',
                name: ''
            });
        }
    }

    exit()
    {
        if (window.ReactNativeWebView && typeof window.ReactNativeWebView.postMessage === 'function')
        {
            window.ReactNativeWebView.postMessage('exit');
        }
    }

    render()
    {
        if (!this.props.config || !this.props.config.visible) return;

        let title = 'Smart Login';
        let infotext = undefined;
        let hint = undefined;
        let form = [];
        let actions = [];
        if (this.state.view == 'email')
        {
            if (this.state.mode == 'login')
            {
                title = this.state.title;
                infotext = this.state.infotext;
                actions.push({
                    title: I.Next,
                    action: this.login.bind(this)
                });
                if (this.state.exit)
                {
                    actions.push({
                        title: this.state.exit,
                        action: this.exit,
                        link: true
                    });
                }
                else if (this.state.pwa && window.trcloud.pwa)
                {
                    actions.push({
                        title: window.trcloud.pwa.return_label,
                        action: () => location.href = window.trcloud.pwa.start_url,
                        link: true
                    });
                }
                form.push(
                    <div class="row">
                        <label>{I.Email}</label>
                        <div class="input">
                            <input type="email" autofocus key="email" value={this.state.email} onKeyDown={this.onKeyDown.bind(this)} onInput={e => this.setState({email: e.target.value})}/>
                        </div>
                    </div>
                );
                form.push(
                    <div class="row hidden">
                        <label>Passwort</label>
                        <div class="input">
                            <input type="password" key="pw" value={this.state.password} onKeyDown={this.onKeyDown.bind(this)} onInput={e => this.setState({password: e.target.value})}/>
                        </div>
                    </div>
                );
            }
            else if (this.state.mode == 'signup')
            {
                title = this.state.signup_title;
                infotext = this.state.signup_infotext;
                if (this.state.signup_agb)
                {
                    form.push(
                        <div class="agb">
                            <input type="checkbox" key="agb" checked={this.state.agb_accepted} onChange={e => this.setState({agb_accepted: e.target.checked})}/>
                            <label dangerouslySetInnerHTML={{__html: this.state.signup_agb}}></label>
                        </div>
                    );
                }
                actions.push({
                    title: 'Account erstellen',
                    action: this.signup.bind(this)
                });
                actions.push({
                    title: 'Abbrechen',
                    action: this.cancel.bind(this),
                    link: true
                });
            }
            else if (this.state.mode == 'otp_login')
            {
                title = this.state.otp_login_title;
                infotext = this.state.otp_login_infotext;

                actions.push({
                    title: 'Code anfordern',
                    action: this.login.bind(this),
                    param: 'request_otp'
                });

                if (this.state.extras.includes('offer_registration'))
                {
                    hint = 'Wir möchten Ihnen gerne die optimale Sicherheit bieten. Sie können uns dabei unterstützen indem Sie ein persönliches Kennwort für Ihren Zugang festlegen. Klicken Sie dazu einfach auf "Kennwort festlegen".';
                    actions.push({
                        title: 'Kennwort festlegen',
                        action: this.signup.bind(this)
                    });
                }

                actions.push({
                    title: 'Abbrechen',
                    action: this.cancel.bind(this),
                    link: true
                });
            }
            else if (this.state.mode == 'reset')
            {
                title = this.state.reset_title;
                infotext = this.state.reset_infotext;
                actions.push({
                    title: 'Neues Passwort festlegen',
                    action: this.reset.bind(this)
                });
                actions.push({
                    title: 'Abbrechen',
                    action: this.cancel.bind(this),
                    link: true
                });
            }
        }
        else if (this.state.view == 'password')
        {
            title = this.state.login_title;
            infotext = this.state.login_infotext;
            
            form.push(
                <div class="row">
                    <label>Passwort</label>
                    <div class="input">
                        <input type="password" key="pw" autofocus value={this.state.password} onKeyDown={this.onKeyDown.bind(this)} onInput={e => this.setState({password: e.target.value})} onChange={e => this.setState({password: e.target.value})} />
                    </div>
                </div>
            );

            actions.push({
                title: 'Anmelden',
                action: this.login.bind(this)
            });
            actions.push({
                title: 'Passwort vergessen?',
                action: this.showLostPassword.bind(this),
                link: true
            });
            actions.push({
                title: 'Abbrechen',
                action: this.cancel.bind(this),
                link: true
            });
        }
        else if (this.state.view == 'otp')
        {
            title = this.state.otp_title;
            infotext = this.state.otp_infotext.replace(/%EMAIL%/g, this.state.email);
            
            form.push(
                <div class="row">
                    <label>Sicherheitscode</label>
                    <div class="input">
                        <input type="text" key="sc" autofocus style="letter-spacing: 0.5em;" pattern="\\d*" maxlength="6" value={this.state.otp} onKeyDown={this.onKeyDown.bind(this)} onInput={e => this.setState({otp: e.target.value})} onChange={e => this.setState({otp: e.target.value})} />
                    </div>
                </div>
            );

            if (this.state.mode == 'reset')
            {
                actions.push({
                    title: 'Weiter',
                    action: this.reset.bind(this)
                });
            }
            else if (this.state.mode == 'signup')
            {
                actions.push({
                    title: 'Weiter',
                    action: this.signup.bind(this)
                });
            }
            else if (this.state.mode == 'login')
            {
                actions.push({
                    title: 'Anmelden',
                    action: this.login.bind(this)
                });
            }
            else if (this.state.mode == 'otp_login')
            {
                actions.push({
                    title: 'Anmelden',
                    action: this.login.bind(this)
                });
            }
            actions.push({
                title: 'Abbrechen',
                action: this.cancel.bind(this),
                link: true
            });
        }
        else if (this.state.view == 'new_password')
        {
            if (this.state.mode == 'reset')
            {
                title = this.state.reset_password_title;
                infotext = this.state.reset_password_infotext;
            }
            else
            {
                title = this.state.new_password_title;
                infotext = this.state.new_password_infotext;
            }
            
            form.push(
                <div class="row">
                    <label>Neues Passwort</label>
                    <div class="input">
                    <input type="password" key="np1" value={this.state.password} onInput={e => this.setState({password: e.target.value})} onChange={e => this.setState({password: e.target.value})} />
                    </div>
                </div>
            );
            form.push(
                <div class="row">
                    <label>Neues Passwort (bestätigen)</label>
                    <div class="input">
                    <input type="password" key="np2" value={this.state.password2} onInput={e => this.setState({password2: e.target.value})} onChange={e => this.setState({password2: e.target.value})} />
                    </div>
                </div>
            );
            form.push(
                <div class="row validation">
                    <ul>
                    <li data-active={this.state.password && !/.{10,}/.test(this.state.password)}>Mindestens 10 Zeichen</li>
                    <li data-active={this.state.password && !/[a-z]/.test(this.state.password)}>Mindestens ein Kleinbuchstabe</li>
                    <li data-active={this.state.password && !/[A-Z]/.test(this.state.password)}>Mindestens ein Großbuchstabe</li>
                    <li data-active={this.state.password && !/[0-9]/.test(this.state.password)}>Mindestens eine Ziffer</li>
                    <li data-active={this.state.password && !/[^a-zA-Z0-9]/.test(this.state.password)}>Mindestens ein Sonderzeichen</li>
                    <li class="only" data-active={this.state.password && this.state.password != this.state.password2}>Passwörter stimmen nicht überein</li>
                    </ul>
                </div>
            );

            if (this.state.mode == 'reset')
            {
                actions.push({
                    title: 'Neues Passwort festlegen',
                    action: this.reset.bind(this)
                });
            }
            else if (this.state.mode == 'signup')
            {
                actions.push({
                    title: 'Weiter',
                    action: this.signup.bind(this)
                });
            }
            actions.push({
                title: 'Abbrechen',
                action: this.cancel.bind(this),
                link: true
            });
        }
        else if (this.state.view == 'name')
        {
            title = this.state.name_title;
            infotext = this.state.name_infotext;
            form.push(
                <div class="row">
                    <label>Angezeigter Name</label>
                    <div class="input">
                        <input type="text" key="name" value={this.state.name} onInput={e => this.setState({name: e.target.value})} onChange={e => this.setState({name: e.target.value})}/>
                    </div>
                </div>
            );
            actions.push({
                title: 'Account erstellen',
                action: this.signup.bind(this)
            });
            actions.push({
                title: 'Abbrechen',
                action: this.cancel.bind(this),
                link: true
            });
        }
        else if (this.state.view == 'server_selection')
        {
            title = this.state.server_selection.title;
            infotext = this.state.server_selection.infotext;
            let selection = 0;
            let onSelect = (e) => {
                selection = e.target.value;
            };
            let onNext = (e) => {
                let option = this.state.server_selection.options[selection];
                if (option.action == 'password_required')
                {
                    this.setState({
                        view: 'password',
                        otp: '',
                        server_selection: undefined
                    });
                }
                if (option.action == 'can_register')
                {
                    this.setState({
                        view: 'email',
                        mode: 'signup',
                        password: '',
                        password2: '',
                        otp: '',
                        server_selection: undefined
                    });
                }
                else if (option.action == 'can_otp_login')
                {
                    this.setState({
                        view: 'email',
                        mode: 'otp_login',
                        password: '',
                        password2: '',
                        otp: '',
                        server_selection: undefined
                    });
                }
                else if (option.action == 'redirect')
                {
                    document.location.href = option.url;
                }
                console.log('next', );
            };
            form.push(
                <div class="row">
                    <label>Server</label>
                    <div class="input">
                        <select onChange={onSelect}>
                            {this.state.server_selection.options.map((option, index) => {
                                return <option value="{index}">{option.title}</option>;
                            })}
                        </select>
                    </div>
                </div>
            );
            actions.push({
                title: 'Weiter',
                action: onNext
            });
            actions.push({
                title: 'Abbrechen',
                action: this.cancel.bind(this),
                link: true
            });
        }

        let footer;
        if (!this.state.exit && this.props.config && this.props.config.footer)
        {
            footer = (
                <div class="footer" data-sso-exclusive={this.props.config.sso && this.props.config.sso.exclusive}>
                    <div class="content" dangerouslySetInnerHTML={{__html: this.props.config.footer.content}}></div>
                    <div class="links">
                        {(this.props.config.footer.links || []).map(f => {
                            return <a href={f.link} target={f.target}>{f.title}</a>;
                        })}
                    </div>
                </div>
            );
        }
        let classic_login = (
            <div class="tile">
                <div class="tcr-form edit" data-edit="true">
                    {form}
                </div>
            </div>
        );
        let sso;
        if (this.props.config.sso && this.props.config.sso.enabled)
        {
            let ssoLabel = this.props.config.sso.label || 'Mit Redvery ID anmelden';
            if (this.props.config.sso.exclusive)
            {
                classic_login = undefined;
                let exitLink = this.state.exit ? [
                    <br/>,
                    <div class="sso-link" onClick={this.exit}>{this.state.exit}</div>
                 ] : undefined;
                sso = (
                    <div class="sso" data-exclusive="true">
                        <div class="sso-button" onClick={TcrLogin.do_sso}>{ssoLabel}</div>
                        {exitLink}
                    </div>
                );
            }
            else
            {
                sso = (
                    <div class="sso">
                        <div class="sso-separator"><div></div><span>Alternative Anmeldeverfahren</span></div>
                        <div class="sso-button" onClick={TcrLogin.do_sso}>{ssoLabel}</div>
                    </div>
                );
            }
        }
        //This fixes the problem of losing focus after first letter is typed.
        //Apparently the dynamic {form} must stand alone inside the tcr-form div.
        form.unshift(
            <div class="form_title noborder">
                {title}
                {infotext ? <div class="form_info">{infotext}</div> : undefined}
                {hint ? [<div class="hint_title">Hinweis:</div>,<div class="hint">{hint}</div>] : undefined}
            </div>
        );
        actions.forEach((a, i) => {
            form.push(
                <button class={a.link ? 'link' : undefined} style={i > 0 ? 'margin-left: 20px' : undefined} onClick={() => a.action(a.param)}>{a.title}</button>
            );
        });
        return (
            <div class="content" data-center="true">
                {classic_login}
                {sso}
                {footer}
            </div>
        );
    }
}

export { TcrLoginForm };

